import { render, staticRenderFns } from "./JobQuery.vue?vue&type=template&id=2a96419c&scoped=true&"
import script from "./JobQuery.vue?vue&type=script&lang=js&"
export * from "./JobQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96419c",
  null
  
)

export default component.exports